import React from 'react'
import RouteMain from '../layout/Route';
import "./App.css";


export default function App() {
  return (
      <RouteMain />
  )
}
